export const ROOT_URL = process.env.ROOT_URL
export const API = process.env.REACT_APP_API_URL;